import { put, takeLatest } from 'redux-saga/effects'
import { GetDataConfirmSuccessAction, GetDataPlanHandleStepSuccessAction, RequertConfirmFaileAction, RequertPlanHandleStepFaileAction } from '../actions';
import { GET_DATA_CONFIRM, GET_DATA_PLANHANDLE_STEP } from '../actions/actionTypes';
import { Api } from './api'

function* GetDataConfirm(action) {
    try {
        const DataPlan = yield Api.GetDataConfirmFromApi(action.DataPlan);
        yield put(GetDataConfirmSuccessAction(DataPlan))
    } catch (error) {
        yield put(RequertConfirmFaileAction(error))
    }
}
export function* watchGetDataConfirm() {
    yield takeLatest(GET_DATA_CONFIRM, GetDataConfirm)
}
function* GetDatalanHandleStep(action) {
    try {
        const DataPlan = yield Api.GetDataPlanHandleStepFromApi(action.DataPlanStep);
        yield put(GetDataPlanHandleStepSuccessAction(DataPlan))
    } catch (error) {
        yield put(RequertPlanHandleStepFaileAction(error))
    }
}
export function* watchGetDataPlanHanldeStep() {
    yield takeLatest(GET_DATA_PLANHANDLE_STEP, GetDatalanHandleStep)
}